/**
 * ITP-E-269-01 — which `dynamicsettings` the page runs on once AllApplications has answered.
 *
 * A production page always runs on its own environment.json settings. Any page also runs on them when the
 * API sends none, which every deployed API does since ITP-E-270: outside Development the API serves no
 * `dynamicsettings` at all. Only a local, non-production page keeps the settings the API served.
 */
export function dynamicSettingsToUse(isProduction: boolean, served: unknown, own: unknown): unknown {
  if (isProduction || served === null || served === undefined) {
    return own;
  }
  return served;
}
